// extracted by mini-css-extract-plugin
export default {"new-cm":"Managers_new-cm__v3q1I","heading":"Managers_heading__ouI61","title":"Managers_title__kRRVz","managersCount":"Managers_managersCount__+HC0o"};